module.exports = __webpack_public_path__ + "img/credit-card (3).630e7539.svg";